import DatePicker, { DatePickerProps } from 'react-datepicker';
import { registerLocale } from 'react-datepicker';
import ptBR from 'date-fns/locale/pt-BR';
import 'react-datepicker/dist/react-datepicker.css';

registerLocale('pt-BR', ptBR);

const CustomDatePicker = (props: DatePickerProps) => {
  return (
    <DatePicker
      locale="pt-BR"
      dateFormat="dd/MM/yyyy"
      {...props}
    />
  );
};

export default CustomDatePicker;
